/**
 * AIRGROW Material Interface — カラートークン
 * DESIGN.md の frontmatter と同値。
 *
 * 使用方法:
 *   import { C } from '../ColorTokens';   // pages/ から参照
 *   import { C } from './ColorTokens';    // src/ 直下から参照
 *   style={{ color: C.primary }}
 */
export const C = {
  // Primary
  primary:                 '#00508e',
  primaryContainer:        '#0068b7',
  onPrimary:               '#ffffff',

  // Surface
  background:              '#f8f9ff',
  surfaceBright:           '#f8f9ff',
  surfaceContainerLow:     '#f2f3fb',
  surfaceContainer:        '#eceef5',
  surfaceContainerHigh:    '#e6e8ef',
  surfaceContainerHighest: '#e0e2e9',

  // On-surface
  onSurface:               '#191c21',
  onSurfaceVariant:        '#414751',

  // Outline
  outline:                 '#717782',
  outlineVariant:          '#c1c7d3',

  // Secondary
  secondary:               '#216d1c',
  secondaryContainer:      '#a3f391',
  onSecondaryContainer:    '#267120',

  // Error
  error:                   '#ba1a1a',
  errorContainer:          '#ffdad6',
  onErrorContainer:        '#93000a',
};
